import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace FeeApi {
    /**
    *  获取费用列表
    */
    export var GetFeeList = (query: any): Promise<any> => {
        return Get(`/msls/Fee/GetFeeList?${qs.stringify(query)}`, {});
    };
    /**
    *  获取费用详情
    */
    export var GetFeeDetail = (query: any): Promise<any> => {
        return Get(`/msls/Fee/getfee?${qs.stringify(query)}`, {});
    };
    /**
    *  导出费用列表
    */
    export var ExportFeeList = (query: any): Promise<any> => {
        return Download(`/msls/Fee/feelistexport?${qs.stringify(query)}`, {});
    };
    /**
     * 导出费用运单列表
     */
    export var ExportFeecarrierorderList = (query: any): Promise<any> => {
        return Download(`/msls/Fee/feecarrierorderlistexport?${qs.stringify(query)}`, {});
    };
    /**
    * 获取账单列表
    */
    export var GetFeeBillList = (query: any): Promise<any> => {
        return Get(`/msls/Fee/GetFeeBillList?${qs.stringify(query)}`, {});
    };
    /**
     * 导出账单列表
     */
    export var ExportFeebilllist = (query: any): Promise<any> => {
        return Download(`/msls/Fee/feebilllistexport?${qs.stringify(query)}`, {});
    };
    /**
     * 导出账单详情中的运单列表
     */
    export var ExportBillDetailList = (query: any): Promise<any> => {
        return Download(`/msls/Fee/feebilldetailexport?${qs.stringify(query)}`, {});
    };
    /**
     * 导出支付记录列表
     */
    export var ExportPayLogList = (query: any): Promise<any> => {
        return Download(`/msls/Fee/payloglistexport?${qs.stringify(query)}`, {});
    };
    /**
    * 获取账单详情
    */
    export var GetFeeBillDetail = (query: any): Promise<any> => {
        return Get(`/msls/Fee/GetFeeBill?${qs.stringify(query)}`, {});
    };
    /**
     * 获取新增账单详情
     */
    export var GetAddFeeBillDetail = (query: any): Promise<any> => {
        return Get(`/msls/Fee/GetAddFeeBillDetail?${qs.stringify(query)}`, {});
    };
    /**
     * 获取费用运单列表（用于费用明细，账单详情等菜单）
     */
    export var GetFeeCarrierOrderList = (query: any): Promise<any> => {
        return Get(`/msls/Fee/GetFeeCarrierOrderList?${qs.stringify(query)}`, {});
    };
    /**
     * 获取支付记录列表
     */
    export var GetPayLogList = (query: any): Promise<any> => {
        return Get(`/msls/Fee/GetPayLogList?${qs.stringify(query)}`, {});
    };
    /**
     * 审核应付（费用审核）
     */
    export var AuditFee = (body: any): Promise<any> => {
        return Put(`/msls/Fee/AuditFee`, body);
    };
    /**
     * 审核费用账单
     */
    export var AuditBill = (body: any): Promise<any> => {
        return Put(`/msls/Fee/updatebillstatus`, body);
    };
    /**
     * 新增支付记录
     */
    export var AddPaymentLog = (body: any): Promise<any> => {
        return Post(`/msls/Fee/AddPaymentLog`, body);
    };
    /**
     * 修改支付记录
     */
    export var EditPaymentLog = (body: any): Promise<any> => {
        return Put(`/msls/Fee/SavePaymentLog`, body);
    };
    /**
     * 删除支付记录
     */
    export var DelPaymentLog = (query: any): Promise<any> => {
        return Put(`/msls/Fee/DeletePaymentLog?${qs.stringify(query)}`, {});
    };
}